import { Injectable } from '@angular/core';
import { AppPermission } from '../interface/common.interface';
import { UserSetting } from '../interface/user.interface';

@Injectable({
  providedIn: 'root',
})
export class UserState {
  userSetting!: UserSetting;
  permittedActions!: AppPermission[];
}
